import type { SourceRecord } from "../use-reference-data";

const normalizeComparableValue = (value: unknown): string => {
  if (value === null || value === undefined) {
    return "";
  }

  return String(value).trim();
};

const forceCecManagedMethodNames = new Set(["web form", "phone", "walked into center", "mcp campaign", "mcp campain"]);

const findSelectedContactMethodSource = (
  sourceId: unknown,
  contactMethodSources?: SourceRecord[]
): SourceRecord | null => {
  const normalizedSourceId = normalizeComparableValue(sourceId);
  if (!normalizedSourceId) {
    return null;
  }

  return (
    contactMethodSources?.find(
      contactMethod => normalizeComparableValue(contactMethod.value).toLowerCase() === normalizedSourceId.toLowerCase()
    ) ?? null
  );
};

const isForceCecManagedMethod = (method?: SourceRecord | null): boolean => {
  if (!method) {
    return false;
  }

  const normalizedName = normalizeComparableValue(method.name).toLowerCase();
  return forceCecManagedMethodNames.has(normalizedName);
};

export const coerceCecManagedValue = (value: unknown): boolean => {
  if (typeof value === "boolean") {
    return value;
  }

  if (typeof value === "number") {
    return value === 1;
  }

  if (typeof value === "string") {
    const normalized = value.trim().toLowerCase();

    if (["true", "1", "yes", "y", "on"].includes(normalized)) {
      return true;
    }

    if (["false", "0", "no", "n", "off", ""].includes(normalized)) {
      return false;
    }
  }

  return false;
};

export const resolveCecManagedValue = ({
  cecEnrollmentStatus,
  sourceId,
  contactMethodSources
}: {
  cecEnrollmentStatus: boolean;
  sourceId: unknown;
  contactMethodSources?: SourceRecord[];
}): boolean => {
  if (!cecEnrollmentStatus) {
    return false;
  }

  const selectedSource = findSelectedContactMethodSource(sourceId, contactMethodSources);
  if (!selectedSource) {
    return false;
  }

  if (isForceCecManagedMethod(selectedSource)) {
    return true;
  }

  return coerceCecManagedValue(selectedSource.cecManagedOption);
};
